<template>
    <section class="product-area area-padding">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-6" v-for="product in products" :key="product.id">
                    <div class="single-product mt-30">
                        <router-link
                                :to="{name: 'product_details', params: {category: product.category.name, productId: product.uniqueId}}">
                        <div style="width: 365px; height: 360px; overflow: hidden">
                            <img id="img" v-lazy="product.files[0].filePath" :alt="product.title"
                                 style="width: 100%">
                        </div>
                            <h6 class="title">{{product.title}}</h6>
                        </router-link>
                        <span style="background: #fb803a">Best Price</span>
                        <ul>
                            <li>Ksh{{product.price | formatNumber}}</li>
                            <li class="item-2">Ksh {{(product.price * 1.1) | formatNumber}}</li>
                        </ul>
                    </div> <!-- single product -->
                </div>
            </div> <!-- row -->
        </div> <!-- container -->
    </section>
</template>

<script>
    export default {
        name: "FeaturedProducts",
        data() {
            return {
                products: []
            }
        },
        methods: {
            getProducts() {
                this.axios.get('/featured-products').then(data => {
                    this.products = data.data
                }).catch(e => {
                    throw new Error(e)
                })
            }
        },
        created() {
            this.getProducts();
        }
    }
</script>

<style scoped>
    #img {
        object-fit: cover;
        width: 100%;
        min-height: 100%;
    }
</style>